import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';

import {
  HeaderContainer,
  Nav,
  LogoLink,
  Logo,
  NavList,
  LogoText,
  TextWrapper,
  Tagline,
  BurgerMenu,
  MobileNav,
  MobileNavItem,
  MobileAuthButton,
  NavItem,
  NavLink,
} from "./Header.styles";

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { session } = useAuth();
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/courses', label: 'Courses' },
    { path: '/resources', label: 'Resources' },
    // { path: '/blog', label: 'Blog' },
    // { path: '/contact', label: 'Contact' },
  ];

  return (
    <HeaderContainer>
      <Nav>
        <LogoLink to="/" onClick={closeMenu}>
          <Logo src="/assets/Light.png" alt="Q3 Learners Logo"/>
          <TextWrapper>
            <LogoText>Q3 Learners</LogoText>
            <Tagline>Empowering the Next Generation of Tech Professionals</Tagline>
          </TextWrapper>
        </LogoLink>

        <BurgerMenu onClick={toggleMenu} aria-label="Toggle navigation">
          {isOpen ? <FaTimes /> : <FaBars />}
        </BurgerMenu>

        <NavList $isOpen={isOpen}>
          {navItems.map((item) => (
            <NavItem key={item.path}>
              <NavLink
                to={item.path}
                className={location.pathname === item.path ? 'active' : ''}
                onClick={closeMenu}
              >
                {item.label}
              </NavLink>
            </NavItem>
          ))}
        </NavList>
      </Nav>

      <MobileNav $isOpen={isOpen}>
        {navItems.map((item) => (
          <MobileNavItem key={item.path}>
            <NavLink
              to={item.path}
              className={location.pathname === item.path ? 'active' : ''}
              onClick={() => setIsOpen(false)}
            >
              {item.label}
            </NavLink>
          </MobileNavItem>
        ))}
        {!session && <MobileAuthButton as="div">Log In</MobileAuthButton>}
      </MobileNav>
    </HeaderContainer>
  );
};

export default Header;
